// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  background: var(--color-neutral);
}

.dashboard__main {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dashboard__topbar {
  height: var(--header-height);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface);
}

.dashboard__topbar-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.dashboard__topbar-right {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-shrink: 0;
}

.dashboard__profile-menu {
  position: relative;
  padding-left: 0.85rem;
  border-left: 1px solid var(--color-border);
}

.dashboard__profile {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.dashboard__profile:hover .dashboard__profile-details strong {
  color: var(--color-accent);
}

.dashboard__avatar {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--color-tertiary);
  color: var(--color-text);
  font-size: 0.72rem;
  font-weight: 700;
  flex-shrink: 0;
}

.dashboard__profile-details strong {
  display: block;
  font-size: 0.82rem;
  line-height: 1.2;
}

.dashboard__profile-details span {
  display: block;
  color: var(--color-text-muted);
  font-size: 0.72rem;
  line-height: 1.2;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard__profile-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  z-index: 20;
  min-width: 220px;
  padding: 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.dashboard__profile-dropdown-user {
  padding: 0.65rem 0.75rem;
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 0.35rem;
}

.dashboard__profile-dropdown-user strong {
  display: block;
  font-size: 0.82rem;
  line-height: 1.2;
}

.dashboard__profile-dropdown-user span {
  display: block;
  margin-top: 0.15rem;
  color: var(--color-text-muted);
  font-size: 0.72rem;
  line-height: 1.2;
  word-break: break-all;
}

.dashboard__profile-dropdown-btn {
  display: block;
  width: 100%;
  padding: 0.65rem 0.75rem;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--color-text);
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.dashboard__profile-dropdown-btn:hover {
  background: var(--color-accent-soft);
  color: var(--color-accent);
}

.dashboard__profile-dropdown-btn--logout {
  margin-top: 0.15rem;
  border-top: 1px solid var(--color-border);
  border-radius: 0 0 8px 8px;
  padding-top: 0.8rem;
}

.menu-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: var(--color-btn);
  color: var(--color-btn-text);
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.menu-toggle:hover {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.menu-toggle svg {
  width: 20px;
  height: 20px;
  color: var(--color-icon);
}

.dashboard__content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1.5rem 1.25rem 3rem;
}

.sidebar-backdrop {
  display: none;
}

.sidebar {
  width: var(--sidebar-width);
  height: 100vh;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1rem;
  background: var(--color-sidebar);
  border-right: 1px solid var(--color-sidebar-border);
  color: var(--color-sidebar-text);
  overflow-y: auto;
}

.sidebar__brand {
  text-align: center;
}

.sidebar__logo {
  display: grid;
  place-items: center;
  width: 76px;
  height: 76px;
  margin: 0 auto 0.75rem;
  border: 1px solid var(--color-sidebar-border);
  border-radius: var(--radius);
  background: #ffffff;
  box-shadow: none;
  overflow: hidden;
}

.sidebar__logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sidebar__brand h1 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--color-sidebar-text);
}

.sidebar__brand p {
  margin: 0.2rem 0 1.5rem;
  color: var(--color-sidebar-text-muted);
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  flex: 1 1;
}

.sidebar__nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.7rem 0.85rem;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #ffffff;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.sidebar__nav-item:hover {
  background: var(--color-sidebar-hover);
  color: #ffffff;
}

.sidebar__nav-item--active {
  background: var(--color-accent-soft);
  color: #ffffff;
}

.sidebar__nav-item--active .app-icon {
  color: var(--color-icon);
}

.nav-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  color: var(--color-icon);
  font-size: 1rem;
  line-height: 1;
}

.nav-icon svg {
  width: 22px;
  height: 22px;
}

.theme-toggle {
  display: inline-flex;
  gap: 0.2rem;
  padding: 0.25rem;
  border: 1px solid var(--color-theme-toggle-border);
  border-radius: 999px;
  background: var(--color-theme-toggle-bg);
}

.theme-toggle__option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: var(--color-theme-toggle-icon);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.theme-toggle__option svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--color-theme-toggle-icon);
}

.theme-toggle__option--active {
  background: var(--color-btn);
  color: var(--color-theme-toggle-icon-active);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);
}

.theme-toggle__option--active svg {
  color: var(--color-theme-toggle-icon-active);
}

.theme-toggle__option:hover:not(.theme-toggle__option--active) {
  background: var(--color-theme-toggle-hover);
  color: var(--color-text);
}

.theme-toggle__option:hover:not(.theme-toggle__option--active) svg {
  color: var(--color-text);
}

@media (max-width: 768px) {
  .menu-toggle {
    display: inline-flex;
  }

  .dashboard__profile-details span {
    display: none;
  }

  .sidebar-backdrop {
    position: fixed;
    inset: 0;
    z-index: 20;
    background: var(--color-backdrop);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
  }

  .sidebar-backdrop--visible {
    display: block;
    opacity: 1;
    pointer-events: auto;
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 30;
    height: 100vh;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    box-shadow: var(--shadow);
  }

  .sidebar--open {
    transform: translateX(0);
  }

  .dashboard__content {
    padding: 1.25rem 1rem 4.5rem 0.75rem;
  }
}

@media (max-width: 480px) {
  .dashboard__topbar {
    padding: 0 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;EAChC,mDAAmD;EACnD,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6CAA6C;EAC7C,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,kDAAkD;EAClD,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,WAAW;IACX,iCAAiC;IACjC,UAAU;IACV,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".dashboard {\n  height: 100vh;\n  min-height: 100vh;\n  overflow: hidden;\n  display: flex;\n  background: var(--color-neutral);\n}\n\n.dashboard__main {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.dashboard__topbar {\n  height: var(--header-height);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1.25rem;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--color-surface);\n}\n\n.dashboard__topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.dashboard__topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  flex-shrink: 0;\n}\n\n.dashboard__profile-menu {\n  position: relative;\n  padding-left: 0.85rem;\n  border-left: 1px solid var(--color-border);\n}\n\n.dashboard__profile {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.dashboard__profile:hover .dashboard__profile-details strong {\n  color: var(--color-accent);\n}\n\n.dashboard__avatar {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--color-tertiary);\n  color: var(--color-text);\n  font-size: 0.72rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.dashboard__profile-details strong {\n  display: block;\n  font-size: 0.82rem;\n  line-height: 1.2;\n}\n\n.dashboard__profile-details span {\n  display: block;\n  color: var(--color-text-muted);\n  font-size: 0.72rem;\n  line-height: 1.2;\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dashboard__profile-dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  z-index: 20;\n  min-width: 220px;\n  padding: 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.dashboard__profile-dropdown-user {\n  padding: 0.65rem 0.75rem;\n  border-bottom: 1px solid var(--color-border);\n  margin-bottom: 0.35rem;\n}\n\n.dashboard__profile-dropdown-user strong {\n  display: block;\n  font-size: 0.82rem;\n  line-height: 1.2;\n}\n\n.dashboard__profile-dropdown-user span {\n  display: block;\n  margin-top: 0.15rem;\n  color: var(--color-text-muted);\n  font-size: 0.72rem;\n  line-height: 1.2;\n  word-break: break-all;\n}\n\n.dashboard__profile-dropdown-btn {\n  display: block;\n  width: 100%;\n  padding: 0.65rem 0.75rem;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--color-text);\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.dashboard__profile-dropdown-btn:hover {\n  background: var(--color-accent-soft);\n  color: var(--color-accent);\n}\n\n.dashboard__profile-dropdown-btn--logout {\n  margin-top: 0.15rem;\n  border-top: 1px solid var(--color-border);\n  border-radius: 0 0 8px 8px;\n  padding-top: 0.8rem;\n}\n\n.menu-toggle {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.menu-toggle:hover {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.menu-toggle svg {\n  width: 20px;\n  height: 20px;\n  color: var(--color-icon);\n}\n\n.dashboard__content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 1.5rem 1.25rem 3rem;\n}\n\n.sidebar-backdrop {\n  display: none;\n}\n\n.sidebar {\n  width: var(--sidebar-width);\n  height: 100vh;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 1.25rem 1rem;\n  background: var(--color-sidebar);\n  border-right: 1px solid var(--color-sidebar-border);\n  color: var(--color-sidebar-text);\n  overflow-y: auto;\n}\n\n.sidebar__brand {\n  text-align: center;\n}\n\n.sidebar__logo {\n  display: grid;\n  place-items: center;\n  width: 76px;\n  height: 76px;\n  margin: 0 auto 0.75rem;\n  border: 1px solid var(--color-sidebar-border);\n  border-radius: var(--radius);\n  background: #ffffff;\n  box-shadow: none;\n  overflow: hidden;\n}\n\n.sidebar__logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.sidebar__brand h1 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--color-sidebar-text);\n}\n\n.sidebar__brand p {\n  margin: 0.2rem 0 1.5rem;\n  color: var(--color-sidebar-text-muted);\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.sidebar__nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  flex: 1;\n}\n\n.sidebar__nav-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.7rem 0.85rem;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #ffffff;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.sidebar__nav-item:hover {\n  background: var(--color-sidebar-hover);\n  color: #ffffff;\n}\n\n.sidebar__nav-item--active {\n  background: var(--color-accent-soft);\n  color: #ffffff;\n}\n\n.sidebar__nav-item--active .app-icon {\n  color: var(--color-icon);\n}\n\n.nav-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  color: var(--color-icon);\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.nav-icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.theme-toggle {\n  display: inline-flex;\n  gap: 0.2rem;\n  padding: 0.25rem;\n  border: 1px solid var(--color-theme-toggle-border);\n  border-radius: 999px;\n  background: var(--color-theme-toggle-bg);\n}\n\n.theme-toggle__option {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--color-theme-toggle-icon);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.theme-toggle__option svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: var(--color-theme-toggle-icon);\n}\n\n.theme-toggle__option--active {\n  background: var(--color-btn);\n  color: var(--color-theme-toggle-icon-active);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);\n}\n\n.theme-toggle__option--active svg {\n  color: var(--color-theme-toggle-icon-active);\n}\n\n.theme-toggle__option:hover:not(.theme-toggle__option--active) {\n  background: var(--color-theme-toggle-hover);\n  color: var(--color-text);\n}\n\n.theme-toggle__option:hover:not(.theme-toggle__option--active) svg {\n  color: var(--color-text);\n}\n\n@media (max-width: 768px) {\n  .menu-toggle {\n    display: inline-flex;\n  }\n\n  .dashboard__profile-details span {\n    display: none;\n  }\n\n  .sidebar-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 20;\n    background: var(--color-backdrop);\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.2s ease;\n  }\n\n  .sidebar-backdrop--visible {\n    display: block;\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 30;\n    height: 100vh;\n    transform: translateX(-100%);\n    transition: transform 0.25s ease;\n    box-shadow: var(--shadow);\n  }\n\n  .sidebar--open {\n    transform: translateX(0);\n  }\n\n  .dashboard__content {\n    padding: 1.25rem 1rem 4.5rem 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard__topbar {\n    padding: 0 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
